import router from './router'
import supportMessages from './localization'

export default {
  router,
  localization: supportMessages,
}
